export default {
    ADD: "Загрузить",
    EDIT: "Заменить",
    DELETE: "Удалить",
    SHOW_PREVIEW: "Посмотреть",
    sizeMessage: (size) => `Размер изображения не должен превышать ${size}`,
    fileExtensionMessage: (extensions) => `Тип изображения должен быть ${extensions}`,
    uploadText: (size, extensions) => `Вы можете загрузить ${extensions}, не более ${size}`
};
